import axios from 'axios';

import config from '../configs';
import utils from '../utils';
import services from '../services';

const applicationService = {
  submitFullApplication: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'application/submit', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getApplicationReview: (successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'application_review')
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, '', '');
        errorCallback(exception);
      });
  },
  enterBankAccount: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'application/enter_bank_account', payload)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, payload, '');
        errorCallback(exception);
      });
  },
  imageUpload: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'common/upload', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  checkBank: (payload, successCallback, errorCallback) => {
    axios
      .get(
        config.apiUrl +
          'grab_bank_check?bank_name=' +
          payload.bank_name +
          '&bank_account_number=' +
          payload.bank_acc,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  reapplyApp: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'reapply', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  imageReUpload: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/v1/images/', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  submitDocFlag: (payload, successCallback, errorCallback) => {
    axios
      .put(
        config.apiBaseUrl +
          'api/v2/submit-document-flag/' +
          payload.appId +
          '/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  submitEmailInApplication: (payload, successCallback, errorCallback) => {
    axios
      .put(config.apiUrl + 'application/submit', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  verifyReferralCode: (refCode, successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'application/validate_referral_code', {
        params: {
          referral_code: refCode,
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, '', '');
        errorCallback(exception);
      });
  },
};

export default applicationService;
